<div class="schools-list-content">
  <div class="content">
    <app-sftp-account-list-filters
      [filters]="filters"
      (filtersUpdated)="updateFilters($event)">
    </app-sftp-account-list-filters>
    <app-sftp-account-list-table
      [dataArr]="sftpAccounts"
      [isLoading]="isLoading"
      [tableFilters]="filters.tableFilters"
      (tableFiltersUpdated)="updateTableFilters($event)">
    </app-sftp-account-list-table>
  </div>
</div>
